import React, { Component } from "react";
import { Segment } from "semantic-ui-react";
import Axios from 'axios';

import AddTitleBar from "../../titleBar/addTitleBar";
import InsertBillingParty from './insertBillingParty';
import { isEmpty } from 'lodash';
import BranchTable from "./branchTable";
import { LOCAL_STORAGE } from "../../utils/constants";

class AddBranches extends Component {
    constructor(props) {
        super(props);
        this.state = {
            title: "add_title",
            branchData: [],
            editData: {},
            rowData: [],
            loadingData: true,
        };
    }

    componentDidMount() {
        if (this.props.location.state && this.props.location.state.title) {
            this.setState({
                title: this.props.location.state.title,
                editData: this.props.location.state,
            }, () => {
                if (this.props.location.state.billingPartyId) {
                    Axios.get(`${process.env.REACT_APP_BASE_URL}/masters/billing_party_branch?customerNumber=${LOCAL_STORAGE.customerNo}&userId=${LOCAL_STORAGE.userId}&billingPartyId=${this.props.location.state.billingPartyId}`, {
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': LOCAL_STORAGE.userToken
                        }
                    })
                        .then((dataArray) => {
                            isEmpty(dataArray)
                                ? this.setState({ loadingData: false, branchData: [] })
                                : this.setState({ loadingData: false, branchData: dataArray.data.resultSet });
                        })
                        .catch((err) => {

                        })
                }
            });
        }
    }

    onFormSubmit = () => {
        this.props.history.push("/billingparty");
        this.props.history.go();
    };

    render() {
        return (
            <React.Fragment>
                <AddTitleBar Title={this.state.title == 'edit_title' ? 'Edit Billing Party' : 'New Billing Party'} LinkName="/billingparty" />
                <div className="m-2">
                    <InsertBillingParty
                        title={this.state.title == 'edit_title' ? 'Edit Billing Party' : 'New Billing Party'}
                        editData={this.state.editData}
                        onFormSubmit={this.onFormSubmit}
                    />
                </div>
                <div className="m-2">
                    {this.state.title == 'edit_title' ?
                        <>
                            <BranchTable
                                editData={this.state.editData}
                                billingPartyID={this.props.location.state.billingPartyId}
                                vendor_code={this.state.editData.transporterCode}
                                BranchList={this.state.branchData}
                                billingPartyBranchData={this.state.branchData}
                                vendorId={this.state.vendorId}
                            />
                        </>
                        :
                        <>
                            <Segment style={{ position: "inherit" }}>
                                <div >
                                    <h6>Note - Branch, User and Rate Chart can be added while editing Billing</h6>
                                </div>
                            </Segment>
                        </>}
                </div>
            </React.Fragment>

        );
    }
}

export default AddBranches;
